import {
  organizationAcceptUser,
  organizationRejectUser,
  organizationUnlockUser,
  organizationInviteUser,
  getCurrentOrganizationUsers,
  updateUserRole as requestUpdateUserRole,
  updateUserStatus as requestUpdateUserStatus
} from "@utils/aegean_api_handler";

import { notify } from "@utils/notifications";

export const GET_ORGANIZATION_USERS_REQUEST = "GET_ORGANIZATION_USERS_REQUEST";
export const GET_ORGANIZATION_USERS_SUCCESS = "GET_ORGANIZATION_USERS_SUCCESS";
export const GET_ORGANIZATION_USERS_ERROR = "GET_ORGANIZATION_USERS_ERROR";

export const ACCEPT_USER_REQUEST = "ACCEPT_USER_REQUEST";
export const ACCEPT_USER_SUCCESS = "ACCEPT_USER_SUCCESS";
export const ACCEPT_USER_ERROR = "ACCEPT_USER_ERROR";

export const REJECT_USER_REQUEST = "REJECT_USER_REQUEST";
export const REJECT_USER_SUCCESS = "REJECT_USER_SUCCESS";
export const REJECT_USER_ERROR = "REJECT_USER_ERROR";

export const UNLOCK_USER_REQUEST = "UNLOCK_USER_REQUEST";
export const UNLOCK_USER_SUCCESS = "UNLOCK_USER_SUCCESS";
export const UNLOCK_USER_ERROR = "UNLOCK_USER_ERROR";

export const INVITE_USER_REQUEST = "INVITE_USER_REQUEST";
export const INVITE_USER_SUCCESS = "INVITE_USER_SUCCESS";
export const INVITE_USER_ERROR = "INVITE_USER_ERROR";

export const UPDATE_USER_ROLE_REQUEST = "UPDATE_USER_ROLE_REQUEST";
export const UPDATE_USER_ROLE_SUCCESS = "UPDATE_USER_ROLE_SUCCESS";
export const SCHEDULE_UPDATE_USER_ROLE = "SCHEDULE_UPDATE_USER_ROLE";
export const UPDATE_USER_ROLE_ERROR = "UPDATE_USER_ROLE_ERROR";

export const UPDATE_USER_STATUS_REQUEST = "UPDATE_USER_STATUS_REQUEST";
export const UPDATE_USER_STATUS_SUCCESS = "UPDATE_USER_STATUS_SUCCESS";
export const UPDATE_USER_STATUS_ERROR = "UPDATE_USER_STATUS_ERROR";

export const fetchOrganizationUsers = () => (dispatch, getState) => {
  const store = getState();

  if (store.organization_users.isFetching || store.organization_users.data) {
    // Request for (somewhat) static data - no need for multiple requests
    return Promise.resolve();
  }

  dispatch({ type: GET_ORGANIZATION_USERS_REQUEST });

  return getCurrentOrganizationUsers()
    .then(({ response }) => {
      dispatch({
        type: GET_ORGANIZATION_USERS_SUCCESS,
        data: response
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_ORGANIZATION_USERS_ERROR,
        error
      });
    });
};

export const acceptUser = userId => (dispatch) => {
  dispatch({ type: ACCEPT_USER_REQUEST });

  return organizationAcceptUser(userId)
    .then(({ response: { message, user } }) => {
      notify(message);
      dispatch({
        type: ACCEPT_USER_SUCCESS,
        user
      });
    })
    .catch((error) => {
      dispatch({
        type: ACCEPT_USER_ERROR,
        error
      });
    });
};

export const rejectUser = userId => (dispatch) => {
  dispatch({ type: REJECT_USER_REQUEST });

  return organizationRejectUser(userId)
    .then(({ response: { message, user } }) => {
      notify(message);
      dispatch({
        type: REJECT_USER_SUCCESS,
        user
      });
    })
    .catch((error) => {
      dispatch({
        type: REJECT_USER_ERROR,
        error
      });
    });
};

export const unlockUser = userId => (dispatch) => {
  dispatch({ type: UNLOCK_USER_REQUEST });

  return organizationUnlockUser(userId)
    .then(({ response: { message, user } }) => {
      notify(message);
      dispatch({
        type: UNLOCK_USER_SUCCESS,
        data: user
      });
    })
    .catch((error) => {
      dispatch({
        type: UNLOCK_USER_ERROR,
        error
      });
    });
};

export const scheduleUpdateUserRole = (userId, scheduledRoleId) => (dispatch) => {
  dispatch({
    type: SCHEDULE_UPDATE_USER_ROLE,
    scheduledRoleId,
    userId
  });
};

export const updateUserRole = (userId, roleId) => (dispatch) => {
  dispatch({ type: UPDATE_USER_ROLE_REQUEST });

  return requestUpdateUserRole(userId, roleId)
    .then(({ response: { message, user } }) => {
      notify(message);
      dispatch({
        type: UPDATE_USER_ROLE_SUCCESS,
        data: user
      });
    })
    .catch((error) => {
      dispatch({
        type: UPDATE_USER_ROLE_ERROR,
        error
      });
    });
};

export const updateUserStatus = (userId, active) => (dispatch) => {
  dispatch({ type: UPDATE_USER_STATUS_REQUEST });

  return requestUpdateUserStatus(userId, active)
    .then(({ response: { message, user } }) => {
      notify(message);
      dispatch({
        type: UPDATE_USER_STATUS_SUCCESS,
        user
      });
    })
    .catch((error) => {
      dispatch({
        type: UPDATE_USER_STATUS_ERROR,
        error
      });
    });
};

export const inviteUser = (email, role_id) => async (dispatch) => {
  dispatch({ type: INVITE_USER_REQUEST });
  try {
    const { response: { message, user } } = await organizationInviteUser({
      email,
      role_id
    });
    notify(message);
    dispatch({
      type: INVITE_USER_SUCCESS,
      data: user
    });
  } catch (error) {
    // TODO: Use the custom error message passed down from the back end -> `message` as opposed to/ in conjunction with `error` from the catch block
    dispatch({
      type: INVITE_USER_ERROR,
      error
    });
    throw error;
  }
};
